const projectList = 
    [
        {
            "title": "Minimally Processed",
            "description": "research driven nutrition guidance",
            "moreDetails": "eating should be easy. But we’ve allowed ultra-processed foods to destroy us.",
            "href": "https://minimally-processed.com/",
        },
        {
            "title": "e-florals",
            "description": "floral bouquet building app",
            "moreDetails": "take a quick mindfulness moment and build a digital floral bouquet",
            "href": "https://e-florals.com/",
        },
        // {
        //     "title": "Wild Roses",
        //     "description": "endometriosis research foundation",
        //     "moreDetails": "I live with endometriosis and work to share research and resources",
        //     "href": "https://www.wild-roses-endometriosis-research.org/",
        // },
        {
            "title": "Noodlepedia",
            "description": "mobile instant noodle rating app",
            "moreDetails": "a comprehensive encyclopedia of every single instant noodle, with ratings, recipes, and more",
            "href": "https://inoodlefactory.com/",
        },
                {
            "title": "Dated",
            "description": "database for online dating platforms",
            "moreDetails": "a backend system that provides better insight into online dating behavior",
            "href": "https://medium.com/@cierrabeck/graph-theory-in-dating-networks-803de3cb9c8b",
        },
        {
            "title": "Butter",
            "description": "restaurant software solutions",
            "moreDetails": "custom insights and tools for restaurants to optimize operations and improve guest engagement",
            "href": "https://www.cerise-technology.com/butter",
        },
        // {
        //     "title": "Eleve",
        //     "description": "bespoke high tech for tasting menus",
        //     "moreDetails": "software solutions for michelin level restaurants to better connect with their guests",
        //      "href": "https://www.cerise-technology.com/eleve",
        // },
        {
            "title": "Work Smarter Fitness",
            "description": "progressive overload workouts",
            "moreDetails": "a minimalistic application that utilizes machine learning to optimize workouts and track progress",
            "href": "https://worksmarterfitness.com/",
        },
        {
            "title": "one of fourteen",
            "description": "productivity and wellness software",
            "moreDetails": "applying product management techniques to daily life, balancing self care and deep focus",
            "href": "http://oneoffourteen.com/",
        },
    ]

export default projectList